import { useQuery } from '@tanstack/react-query';
import { useClientStore } from '../store/client.store.js';
import { useAuthStore } from '../store/auth.store.js';
import { apiGet } from '../api/client.js';

export const useMpMap = ({ enabled = false } = {}) => {
  const user = useAuthStore((s) => s.user);
  const { selectedClientId } = useClientStore();
  const clientId = user?.role === 'superadmin' ? selectedClientId : user?.clientId;

  return useQuery({
    queryKey: ['mp-map', clientId],
    queryFn: () => clientId
      ? apiGet(`/clients/${clientId}/mp-map`)
      : apiGet('/mp-map'),
    enabled: !!clientId && enabled,
    staleTime: 30_000,
    retry: 1,
  });
};
